import {ContentChild, Directive, Input, TemplateRef} from '@angular/core';
import {DataTableDetailsTemplateDirective} from './datatable-details-template.directive';

// tslint:disable-next-line:directive-selector
@Directive({ selector: 'storever-datatable-details' })
export class DataTableDetailsDirective {
  @ContentChild(DataTableDetailsTemplateDirective, { read: TemplateRef }) template: TemplateRef<any>;
}
